const localLayerExports: Map<string, string | Blob> = new Map()

export function setLocalExportData(jobId: string, data: string | Blob) {
  return localLayerExports.set(jobId, data)
}

export function getLocalExportData(jobId: string) {
  return localLayerExports.get(jobId)
}

export function clearLocalLayerExportData(jobId: string) {
  return localLayerExports.delete(jobId)
}
